import * as React from 'react';
import styled from 'styled-components';
import { Flex } from '../../../../../designSystem/compositeComponents/FlexHelpers';
import { Icon } from '../../../../../designSystem/icons/Icons';
import { H3 } from '../../../../../designSystem/typography/Heading';

export function EnvironmentBanner():JSX.Element
{
    const hostname = document.location.hostname;
    let env: 'test' | 'localhost' | 'other' = 'other';

    if (hostname === 'apptest.amorg.dk') {
        env = 'test';
    } else if (hostname === 'localhost') {
        env = 'localhost';
    }

    return (
        <>
            {(env === 'test' || env === 'localhost') &&
            <Banner>
                <Flex justifyContent='center' gap={8}>
                    <Icon name='construction' color="black" />
                    <H3>
                        {env}
                    </H3>
                </Flex>
            </Banner>
            }
        </>
    );
}

const Banner = styled.div`
    padding: 8px 16px;
    text-align: center;
    background: rgba(255,119,174,1);
    
    left:auto;
    
    z-index: 1000;
    
    align-items: end;
    display: flex;
    
    justify-content: center;
    padding: 8px 32px;

`;